import olGeomLineString from 'ol/geom/LineString.js';

export function create2DLineStringFrom2Points(p1, p2) {
  const coo1 = p1.getCoordinates();
  const coo2 = p2.getCoordinates();
  const coordinates = [
    coo1.slice(0, 2),
    coo2.slice(0, 2),
  ];
  return new olGeomLineString(coordinates);
}
